/**
 * Valuation Tab
 * 
 * Shows pricing method, current valuation, and valuation history table
 */

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { formatCurrency } from '@/lib/portfolioCalculations';
import type { UnifiedAsset } from '@/hooks/useAssetsUnified';

interface ValuationTabProps {
  asset: UnifiedAsset;
  data: any;
}

export function ValuationTab({ asset, data }: ValuationTabProps) {
  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle className="text-base">Valuation History</CardTitle>
        </CardHeader>
        <CardContent>
          {data.valuationHistory && data.valuationHistory.length > 0 ? (
            <div className="border rounded-lg">
              <Table>
                <TableHeader>
                  <TableRow>
                    <TableHead>Date</TableHead>
                    <TableHead className="text-right">Value</TableHead>
                    <TableHead>Source</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {data.valuationHistory.map((row: any, idx: number) => (
                    <TableRow key={idx}>
                      <TableCell>
                        {new Date(row.as_of || row.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                      </TableCell>
                      <TableCell className="text-right font-medium">
                        {formatCurrency(row.value, asset.currency, { showDecimals: true, showCurrency: true, locale: 'en-CA' })}
                      </TableCell>
                      <TableCell>
                        <Badge variant="secondary">{row.source || 'User'}</Badge>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          ) : (
            <div className="border rounded-lg p-6 text-center text-muted-foreground">No valuation history available</div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
